export default {"src":"/_next/static/media/dog-owner.80936cba.svg","height":78,"width":78,"blurWidth":0,"blurHeight":0};